import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { initialWhatsAppTemplateState } from "./defaultState";
import {
  FETCH_WHATSAPP_TEMPLATE_LIST_PROGRESS,
  FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS,
  FETCH_WHATSAPP_TEMPLATE_LIST_FAILED,
  FETCH_WHATSAPP_TEMPLATE_PROGRESS,
  FETCH_WHATSAPP_TEMPLATE_SUCCESS,
  CLEAR_WHATSAPP_TEMPLATE_STATE,
} from "./whatsappTemplateAction";

export const whatsappTemplateReducer = (
  state: IStoreState["whatsappTemplate"] = initialWhatsAppTemplateState,
  action: any
) => {
  switch (action.type) {
    // List Actions
    case FETCH_WHATSAPP_TEMPLATE_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
    }

    case FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = data;
        draftState.list.totalRecords = totalRecords;
        draftState.list.error = null;
        // Old paging structure (kept for reference)
        // draftState.list.paging = paging;
      });
    }

    case FETCH_WHATSAPP_TEMPLATE_LIST_FAILED: {
      const { errorMessage } = action?.payload || "Something went wrong";
      return produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.error = errorMessage || "Something went wrong";
      });
    }
    case FETCH_WHATSAPP_TEMPLATE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplateData.loading = LoadState.InProgress;
        draftState.whatsAppTemplateData.data =
          initialWhatsAppTemplateState.whatsAppTemplateData.data;
      });
      return newState;
    }
    case FETCH_WHATSAPP_TEMPLATE_SUCCESS: {
      const { data } = action.payload;

      const newState = produce(state, (draftState) => {
        draftState.whatsAppTemplateData.loading = LoadState.Loaded;
        draftState.whatsAppTemplateData.data = data;
      });

      return newState;
    }

    case CLEAR_WHATSAPP_TEMPLATE_STATE: {
      return initialWhatsAppTemplateState;
    }

    default: {
      return state;
    }
  }
};
